import React, { useEffect, useRef, useState } from "react";
import FooterSmallNew from "components/Footers/FooterSmallNew";
import Footer from "components/Footers/Footer";
import { useTranslation } from "react-i18next";
import { useLanguage } from "components/Homepage/LanguageContext";
import IndexNavbar2 from "components/Navbars/IndexNavbar2";

import fish from "assets/img/icon/fish.png";
import whitefish from "assets/img/icon/whitefish.png";
import service from "assets/img/services.webp";

import header1 from "assets/img/header1.png";

import review from "assets/img/review.png";
import imagee1 from "assets/img/imagee1.webp";

import imagee4 from "assets/img/imagee4.webp";
import imagee5 from "assets/img/imagee5.webp";
import imagee6 from "assets/img/imagee6.webp";
import quality from "assets/img/quality-01.webp";
import fishharvestingg from "assets/img/fish-harvesting-in-seashore.jpg";
import fishharvesting from "assets/img/fish-harvesting-01.webp";
import exportimg from "assets/img/exportimg.webp";
import distributionnetwork from "assets/img/Distribution-Network.webp";

const Service = () => {
  const { t } = useTranslation();
  const { changeLanguage } = useLanguage();

  // Scroll down animation
  const sections = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    sections.current.forEach((section) => {
      if (section && section instanceof Element) {
        observer.observe(section);
      }
    });

    const handleScroll = debounce(() => {
      sections.current.forEach((section) => {
        if (section && section instanceof Element) {
          observer.observe(section);
        }
      });
    }, 100);

    window.addEventListener("scroll", handleScroll);

    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  }

  // Counting numbers
  const [count1, setCount1] = useState(0);
  const [count2, setCount2] = useState(0);
  const [count3, setCount3] = useState(0);
  const [count4, setCount4] = useState(0);
  const sectionRef = useRef(null);
  const startedRef = useRef(false);

  const sectionRef1 = useRef(null);
  const startedRef1 = useRef(false);

  const animateCount = (target, setter, duration) => {
    let start = 0;
    const increment = target / (duration / 10);

    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        start = target;
        clearInterval(timer);
      }
      setter(Math.ceil(start));
    }, 10);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !startedRef.current) {
          animateCount(100, setCount1, 2500, true);
          animateCount(1500, setCount2, 2500, true);
          animateCount(287, setCount3, 2500, true);
          animateCount(30, setCount4, 2500);
          startedRef.current = true;
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (observer && sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section>
      <IndexNavbar2 />
      <section className="xl:pt-28 lg:pt-28 md:pt-17 pt-17"></section>
      <section
        ref={(el) => sections.current.push(el)}
        style={{
          position: "relative",
          backgroundImage: `url(${service})`,
          // backgroundAttachment: "fixed",
          width: "100%",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        className="animate-on-scroll xl:h-450 lg:h-300 md:h-300 justify-center text-white"
      >
        <div className="">
          <div className="container mx-auto overflow-hidden hometext xl:px-24 px-4">
            <div className="grid md:grid-cols-2 ">
              <div className="text-left bg-dark-blue xl:p-16 lg:p-12 md:p-12 p-12">
                <h1 className="banner-font text-white xl:pt-16 lg:pt-5 md:mt-4  font-extrabold xl:text-head1 lg:text-head1 headlineheight md:text-head1 text-head1 md:text-xl text-2xl uppercase">
                  {t("servicecontent1")}
                </h1>
                <p className="pt-2 xl:pt-2 text-white xl:mb-19 lg:mb-8 md:mb-2 banner-font xl:text-lg text-lg md:text-base">
                  {" "}
                  {t("servicecontent2")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className=""
        style={{
          backgroundColor: "rgb(0 149 207 / 7%)",
          backgroundSize: "cover",
        }}
      >
        <div className="container mx-auto overflow-hidden px-4 xl:py-16 lg:py-16 md:py-12 py-12 xl:px-24">
          <div className="center-items">
            <h1 className="banner-font uppercase text-dark-blue font-bold xl:text-head1 lg:text-head1 headlineheight md:text-head1 text-head1 md:text-xl text-2xl">
              {" "}
              {t("servicecontent3")}
            </h1>
            <p className="pt-2 xl:w-8/12 md:w-8/12 xl:pt-2 text-grey xl:mb-18 banner-font xl:text-lg text-lg">
              {" "}
              {t("servicecontent4")}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-2 xl:mt-0 lg:mt-12 md:mt-12 mt-12">
            <div className="flex justify-center px-2 h-full w-full">
              <div className="shadow-md w-full max-w-xs flex flex-col">
                <img src={imagee1} className="w-full" />
                <div className="flex-1 xl:p-8 lg:p-8 md:p-6 p-6 bg-white flex flex-col justify-between">
                  <div>
                    <h1 className="lg:text-head11 xl:text-head11 md:text-head11 text-head11 banner-font text-black font-medium text-center header-on-hover">
                      {t("servicecontent5")}
                    </h1>
                    <p className="xl:pt-2 text-center xl:text-para text-base text-gray leading-relaxed headlineheight banner-font">
                      {t("servicecontent6")}
                    </p>
                  </div>
                  <div className="text-center border-t xl:pt-8 xl:mt-8 lg:mt-8 lg:pt-8 md:pt-6 md:mt-6 mt-6 pt-6 uppercase text-xs font-bold text-dark-blue">
                    <a href="/products">{t("servicecontent7")}</a>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-center px-2 h-full w-full">
              <div className="shadow-md w-full max-w-xs flex flex-col">
                <img src={exportimg} className="w-full" />
                <div className="flex-1 xl:p-8 lg:p-8 md:p-6 p-6 bg-white flex flex-col justify-between">
                  <div>
                    <h1 className="lg:text-head11 xl:text-head11 md:text-head11 text-head11 banner-font text-black font-medium text-center header-on-hover">
                      {t("servicecontent8")}
                    </h1>
                    <p className="xl:pt-2 text-center xl:text-para text-base text-gray leading-relaxed headlineheight banner-font">
                      {t("servicecontent9")}
                    </p>
                  </div>
                  <div className="text-center border-t xl:pt-8 xl:mt-8 lg:mt-8 lg:pt-8 md:pt-6 md:mt-6 mt-6 pt-6 uppercase text-xs font-bold text-dark-blue">
                    <a href="/products">{t("servicecontent7")}</a>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-center px-2 h-full w-full">
              <div className="shadow-md w-full max-w-xs flex flex-col">
                <img src={distributionnetwork} className="w-full" />
                <div className="flex-1 xl:p-8 lg:p-8 md:p-6 p-6 bg-white flex flex-col justify-between">
                  <div>
                    <h1 className="lg:text-head11 xl:text-head11 md:text-head11 text-head11 banner-font text-black font-medium text-center header-on-hover">
                      {t("servicecontent10")}
                    </h1>
                    <p className="xl:pt-2 text-center xl:text-para text-base text-gray leading-relaxed headlineheight banner-font">
                      {t("servicecontent11")}
                    </p>
                  </div>
                  <div className="text-center border-t xl:pt-8 xl:mt-8 lg:mt-8 lg:pt-8 md:pt-6 md:mt-6 mt-6 pt-6 uppercase text-xs font-bold text-dark-blue">
                    <a href="/products">{t("servicecontent7")}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-2 xl:mt-12 lg:mt-12 md:mt-8 mt-8">
            <div className="flex justify-center px-2 h-full w-full">
              <div className="shadow-md w-full max-w-xs flex flex-col">
                <img src={imagee4} className="w-full" />
                <div className="flex-1 xl:p-8 lg:p-8 md:p-6 p-6 bg-white flex flex-col justify-between">
                  <div>
                    <h1 className="lg:text-head11 xl:text-head11 md:text-head11 text-head11 banner-font text-black font-medium text-center header-on-hover">
                      {t("servicecontent12")}
                    </h1>
                    <p className="xl:pt-2 text-center xl:text-para text-base text-gray leading-relaxed headlineheight banner-font">
                      {t("servicecontent13")}
                    </p>
                  </div>
                  <div className="text-center border-t xl:pt-8 xl:mt-8 lg:mt-8 lg:pt-8 md:pt-6 md:mt-6 mt-6 pt-6 uppercase text-xs font-bold text-dark-blue">
                    <a href="/products">{t("servicecontent7")}</a>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-center px-2 h-full w-full">
              <div className="shadow-md w-full max-w-xs flex flex-col">
                <img src={imagee5} className="w-full" />
                <div className="flex-1 xl:p-8 lg:p-8 md:p-6 p-6 bg-white flex flex-col justify-between">
                  <div>
                    <h1 className="lg:text-head11 xl:text-head11 md:text-head11 text-head11 banner-font text-black font-medium text-center header-on-hover">
                      {t("servicecontent14")}
                    </h1>
                    <p className="xl:pt-2 text-center xl:text-para text-base text-gray leading-relaxed headlineheight banner-font">
                      {t("servicecontent15")}
                    </p>
                  </div>
                  <div className="text-center border-t xl:pt-8 xl:mt-8 lg:mt-8 lg:pt-8 md:pt-6 md:mt-6 mt-6 pt-6 uppercase text-xs font-bold text-dark-blue">
                    <a href="/products">{t("servicecontent7")}</a>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-center px-2 h-full w-full">
              <div className="shadow-md w-full max-w-xs flex flex-col">
                <img src={quality} className="w-full" />
                <div className="flex-1 xl:p-8 lg:p-8 md:p-6 p-6 bg-white flex flex-col justify-between">
                  <div>
                    <h1 className="lg:text-head11 xl:text-head11 md:text-head11 text-head11 banner-font text-black font-medium text-center header-on-hover">
                      {t("servicecontent16")}
                    </h1>
                    <p className="xl:pt-2 text-center xl:text-para text-base text-gray leading-relaxed headlineheight banner-font">
                      {t("servicecontent17")}
                    </p>
                  </div>
                  <div className="text-center border-t xl:pt-8 xl:mt-8 lg:mt-8 lg:pt-8 md:pt-6 md:mt-6 mt-6 pt-6 uppercase text-xs font-bold text-dark-blue">
                    <a href="/products">{t("servicecontent7")}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="xl:block lg:block md:hidden sm:hidden hidden">
        <section
          ref={(el) => sections.current.push(el)}
          style={{
            position: "relative",
            width: "100%",
            //   height: "100vh",
            background:
              "linear-gradient(to right, #EDF8FC 40%, rgb(22, 9, 53) 40%)" /* Adjust colors as needed */,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
          className="animate-on-scroll justify-center text-white xl:py-16 xl:h-660 h-550 md:h-500  "
        >
          <div className="container mx-auto ">
            <div className="md:flex flex-none xl:w-12/12">
              <div>
                <div className="z-1">
                  <img src={fishharvesting} className="xl:h-530" />
                </div>
                <div className="z-2 relative rounded-md bg-whitee xl:p-12 lg:p-12 md:p-12 p-12 xl:ml-55 xl:-mr-20 xl:-mt-maxxx">
                  <div
                    className="grid md:grid-cols-1 grid-cols-1"
                    ref={sectionRef}
                  >
                    <div className="xl:pl-12">
                      <div className="flex">
                        <div>
                          <img
                            src={header1}
                            className="xl:w-12 xl:h-12 lg:h-12 lg:w-12 md:h-12 md:h-12 h-12 w-12 xl:mt-2"
                          />
                        </div>
                        <div className="xl:pl-2 pl-4 md:pl-4">
                          <h1 className="text-dark-blue lg:text-head1 xl:text-head1 md:text-head1 text-head111 banner-font font-medium">
                            {count1}+<p></p>
                          </h1>
                          <p className="xl:pt-1 xl:text-para text-base text-gray leading-relaxed headlineheight banner-font">
                            {" "}
                            {t("aboutcontent24")}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className=" xl:pl-12 xl:pt-8 pt-4">
                      <div className="flex">
                        <div>
                          <img
                            src={review}
                            className="xl:w-12 xl:h-12 lg:h-12 lg:w-12 md:h-12 md:h-12 h-12 w-12 xl:mt-2"
                          />
                        </div>
                        <div className="xl:pl-2 pl-4 md:pl-4">
                          <h1 className="text-dark-blue lg:text-head1 xl:text-head1 md:text-head1 text-head111 banner-font font-medium">
                            {count2}+<p></p>
                          </h1>
                          <p className="xl:pt-1 xl:text-para text-base text-gray leading-relaxed headlineheight banner-font">
                            {" "}
                            {t("aboutcontent26")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="xl:w-7/12 xl:pl-8 container mx-auto overflow-hidden">
                <div className="text-left xl:p-16 lg:p-16 md:p-6 xl:mt-0 lg:mt-6 md:mt-0 mt-0">
                  <h1 className=" banner-font uppercase text-white font-bold xl:text-head1 lg:text-head1 headlineheight md:text-head1 text-head1 md:text-xl text-2xl">
                    {" "}
                    {t("servicecontent18")}
                  </h1>
                  <p className="pt-2 xl:w-12/12 xl:pt-2 text-white xl:mb-18 banner-font xl:text-lg text-lg">
                    {" "}
                    {t("servicecontent19")}
                  </p>
                  <div className="grid xl:grid-cols-2 md:grid-cols-1 xl:pr-32 xl:pt-0 md:pt-4">
                    <div className="flex">
                      <div>
                        <img
                          src={whitefish}
                          className="xl:w-16 xl:h-16 md:w-12 md:h-12"
                        />
                      </div>
                      <div className="xl:pl-4 md:pl-4">
                        <h1 className="text-white lg:text-head11 xl:text-base md:text-head11 text-head11 banner-font font-medium pt-2">
                          {" "}
                          {t("servicecontent20")}
                        </h1>
                        <p className="xl:pt-1 xl:text-sm text-base text-light-white leading-relaxed headlineheight banner-font">
                          {" "}
                          {t("servicecontent21")}
                        </p>
                      </div>
                    </div>
                    <div className="flex xl:pt-0 lg:pt-0 md:pt-4 xl:ml-2 lg:ml-0 md:ml-0 ml-0">
                      <div>
                        <img
                          src={fish}
                          className="xl:w-16 xl:h-16 md:w-12 md:h-12"
                        />
                      </div>
                      <div className="xl:pl-2 md:pl-4">
                        <h1 className="text-white lg:text-head11 xl:text-base md:text-head11 text-head11 banner-font font-medium pt-2">
                          {" "}
                          {t("servicecontent22")}
                        </h1>
                        <p className="xl:pt-1 xl:text-sm text-base text-light-white leading-relaxed headlineheight banner-font">
                          {" "}
                          {t("servicecontent23")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>

      {/*tab and mobile view*/}
      <section className="xl:hidden lg:hidden md:block sm:block block px-4">
        <div className="relative pt-4">
          <img src={fishharvesting} className="md:w-10/12 w-12/12 mx-auto" />

          <div className="">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="z-1 bg-whitee rounded-md p-4 md:w-8/12 w-8/12">
                <div
                  className="grid md:grid-cols-1 grid-cols-1 gap-4"
                  ref={sectionRef1}
                >
                  <div className="flex items-center">
                    <img src={header1} className="w-12" />
                    <div className="pl-4">
                      <h1 className="text-dark-blue md:text-head1 text-head111 font-bold banner-font">
                        100+
                      </h1>
                      <p className="text-base text-gray leading-relaxed headlineheight banner-font">
                        {t("aboutcontent24")}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center pt-4">
                    <img src={review} className="w-12" />
                    <div className="pl-4">
                      <h1 className="text-dark-blue md:text-head1 text-head111 banner-font font-medium">
                        1500+
                      </h1>
                      <p className="text-base text-gray leading-relaxed headlineheight banner-font">
                        {t("aboutcontent26")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="center-items">
          <div className="text-left  md:p-6 p-6 md:mt-4 mt-4 bg-dark md:w-10/12 w-12/12">
            <h1 className=" banner-font uppercase text-white font-bold  headlineheight md:text-head1 text-head1 md:text-xl text-2xl">
              {" "}
              {t("servicecontent18")}
            </h1>
            <p className="pt-2  text-white banner-font  text-lg">
              {" "}
              {t("servicecontent19")}
            </p>
            <div className="  md:grid-cols-2  md:pt-4 pt-4">
              <div className="flex">
                <div>
                  <img src={whitefish} className=" md:w-12 md:h-12 w-12" />
                </div>
                <div className=" md:pl-4 pl-4">
                  <h1 className="text-white  md:text-head11 text-head11 banner-font font-medium ">
                    {" "}
                    {t("servicecontent20")}
                  </h1>
                  <p className="text-base text-light-white leading-relaxed headlineheight banner-font">
                    {" "}
                    {t("servicecontent21")}
                  </p>
                </div>
              </div>
              <div className="flex  md:pt-4 pt-4 md:ml-0 ml-0">
                <div>
                  <img src={fish} className="md:w-12 md:h-12 w-12" />
                </div>
                <div className=" md:pl-4 pl-4">
                  <h1 className="text-white  md:text-head11 text-head11 banner-font font-medium ">
                    {" "}
                    {t("servicecontent22")}
                  </h1>
                  <p className=" text-base text-light-white leading-relaxed headlineheight banner-font">
                    {" "}
                    {t("servicecontent23")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <FooterSmallNew />
    </section>
  );
};
export default Service;
